import { Outlet } from "react-router-dom";

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top_left,rgba(29,78,216,0.1),transparent_28%),radial-gradient(circle_at_80%_18%,rgba(215,38,56,0.08),transparent_24%)]">
      <main>
        <Outlet />
      </main>
    </div>
  );
}
